import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cache-error-modal',
  templateUrl: './cache-error-modal.component.html',
  styleUrls: ['./cache-error-modal.component.scss'],
  standalone: false,
})
export class CacheErrorModalComponent {

  constructor(private dialog: MatDialog) {
  }

  onClose() {
    this.dialog.closeAll()
  }

  refreshBrowser() {
    window.location.reload()
  }
}
